import {
  success,
  unauthorized,
  clean,
  failure,
  invalid,
  request,
} from "./helpers";
import { today } from "../utils/utility";
import { fromJS } from "immutable";
import { find, isNil } from "lodash";

import {
  SHOW_LOGIN_DIALOG,
  CLOSE_LOGIN_DIALOG,
  SET_EMAIL,
  SET_PASSWORD,
  LOGIN,
  LOGOUT,
  MOUNT_SESSION,
  SELECT_CLIENT,
  USER_CLIENTS,
  USER_AVATAR,
  LOGIN_USER_DETAIL,
  SEND_PASSWORD_RECOVERY,
  RESET_PASSWORD,
  GET_API_BUILD_NUMBER,
  GET_CLIENT_BYID,
  GET_DISABLED_FEATURES,
  CLEAR_CLIENT_INFO,
  OPTIMIZE_USER_DETAIL,
  SET_LOGIN_ERROR_MESSAGE,
} from "../actions/App";
export const app = (
  state = {
    selected_client: "0",
    sendRecoveryEmailSuccess: false,
    sendRecoveryEmailFailMessage: undefined,
  },
  action,
) => {
  switch (action.type) {
    case request(GET_DISABLED_FEATURES):
      return Object.assign({}, state, {
        disabledFeatures: action.payload,
        loadingDisabledFeatures: true,
      });
    case success(GET_DISABLED_FEATURES):
      return Object.assign({}, state, {
        disabledFeatures: action.payload,
        loadingDisabledFeatures: false,
      });
    case SHOW_LOGIN_DIALOG:
      return Object.assign({}, state, {
        loginDialog: true,
      });
    case CLOSE_LOGIN_DIALOG:
      return Object.assign({}, state, {
        loginDialog: false,
        incorrectLogin: false,
      });
    case SET_LOGIN_ERROR_MESSAGE:
      return Object.assign({}, state, {
        loginErrorMessage: action.value,
      });
    case request(LOGIN):
      return {
        ...state,
        loginErrorMessage: null,
      };
    case success(LOGIN):
      let expirationTime = today()
        .add(action.payload.expires_in_minutes, "minutes")
        .valueOf();
      delete state.password;
      window.localStorage.setItem("aa_access_token", action.payload.token);

      return Object.assign({}, state, {
        loggedIn: true,
        clients: null,
        userId: action.payload.userId,
        roleId: action.payload.roleId,
        roleName: action.payload.roleName,
        token: action.payload.token,
        tokenExpirationTime: expirationTime,
        loginDialog: false,
        loginErrorMessage: null,
      });
    case failure(LOGIN):
      return Object.assign({}, state, {
        loggedIn: false,
        loginDialog: true,
        loginErrorMessage: "Incorrect username / password.",
      });
    case LOGOUT:
      state = fromJS(state);
      return state
        .set("loginDialog", false)
        .set("userId", null)
        .set("token", null)
        .toJS();
    case MOUNT_SESSION:
      return Object.assign({}, state, {
        userId: action.value.userId,
        roleId: action.value.roleId,
        roleName: action.value.roleName,
        token: action.value.token,
        tokenExpirationTime: action.value.tokenExpirationTime,
        loginTime: action.value.loginTime,
        apiBuildNumber: action.value.apiBuildNumber,
      });
    case success(USER_CLIENTS):
      return {
        ...state,
        clients: action.payload,
      };
    case success(USER_AVATAR):
      return {
        ...state,
        avatar: action.payload,
      };
    case success(LOGIN_USER_DETAIL):
      return {
        ...state,
        loginUserDetail: action.payload,
      };
    case success(OPTIMIZE_USER_DETAIL):
      return {
        ...state,
        loadingOptimizeUserDetail: false,
        optimizeUserDetail: action.payload,
      };
    case request(OPTIMIZE_USER_DETAIL):
      return {
        ...state,
        loadingOptimizeUserDetail: true,
      };
    case failure(OPTIMIZE_USER_DETAIL):
    case invalid(OPTIMIZE_USER_DETAIL):
    case unauthorized(OPTIMIZE_USER_DETAIL):
      return {
        ...state,
        loadingOptimizeUserDetail: false,
        optimizeUserDetail: undefined,
      };
    case unauthorized(clean(action.type)):
      const message =
        action.payload && action.payload.message
          ? action.payload.message
          : "Incorrect username/password";
      return Object.assign({}, state, {
        loggedIn: false,
        loginDialog: true,
        loginErrorMessage: message,
      });
    case SET_EMAIL:
      return Object.assign({}, state, {
        email: action.value,
      });
    case SET_PASSWORD:
      return Object.assign({}, state, {
        password: action.value,
      });
    case SELECT_CLIENT:
      return {
        ...state,
        selected_client: action.value,
      };
    case success(SEND_PASSWORD_RECOVERY):
      return {
        ...state,
        sendRecoveryEmailSuccess: true,
        sendRecoveryEmailFailMessage: undefined,
      };
    case invalid(SEND_PASSWORD_RECOVERY):
    case failure(SEND_PASSWORD_RECOVERY):
      return {
        ...state,
        sendRecoveryEmailSuccess: false,
        sendRecoveryEmailFailMessage: action.payload.message,
      };
    case success(GET_API_BUILD_NUMBER):
      return {
        ...state,
        apiBuildNumber: action.payload,
      };
    case success(RESET_PASSWORD):
      return {
        ...state,
        resetPasswordSuccess: true,
        resetPasswordFailMessage: undefined,
      };
    case invalid(RESET_PASSWORD):
    case failure(RESET_PASSWORD):
      return {
        ...state,
        resetPasswordSuccess: false,
        resetPasswordFailMessage: action.payload.message,
      };
    case success(GET_CLIENT_BYID):
      const pid = action.payload.parentClientId;
      let isBU = false;
      let parentClient = undefined;
      if (pid) {
        parentClient = find(state["clients"], (client) => {
          return client.id === pid;
        });
        if (!isNil(parentClient)) isBU = true;
      }
      if (isBU === true) {
        return {
          ...state,
          client_info: action.payload,
          parent_client: parentClient,
        };
      } else {
        state = fromJS(state);
        return state
          .set("client_info", action.payload)
          .remove("parent_client")
          .toJS();
      }

    case failure(GET_CLIENT_BYID):
      return {
        ...state,
        client_info: "",
      };
    case CLEAR_CLIENT_INFO:
      return {
        ...state,
        client_info: undefined,
      };
    default:
      return state;
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/reducers/app.js